import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'fields'];

  static values = { userId: String };

  connect() {
    this.toggle();
  }

  toggle() {
    const selected = Array.from(this.selectTarget.selectedOptions).map((option) => option.value);
    this.fieldsTarget.classList.toggle('d-none', !selected.includes(this.userIdValue));
  }
}
